function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.813 4.25v14.625M1 15.5l2.813 3.375L6.625 15.5m12.272 7.875h-3.86a.546.546 0 01-.47-.254.457.457 0 01.015-.499l4.336-6.369a.457.457 0 00.016-.498.546.546 0 00-.466-.255h-3.86M14.5 8.75V2.844c0-1.088 1.007-1.969 2.25-1.969S19 1.756 19 2.844V8.75m-4.5-3.937H19",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fillRule: "evenodd",
  fill: "none"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.658 4.38c.098.098.842.748 1.573 1.868.747 1.144.982 1.446 1.082 1.966.018.097 0 .099 0 .197v.098h0",
  opacity: "undefined",
  stroke: "#000",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  opacity: "undefined",
  stroke: "#000",
  fill: "none",
  d: "M-6.863 8.706h0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.658 4.183c0 .148-.145.454-.367.885-.157.305-.41.612-.55.885-.1.193-.735.737-1.102 1.18-.367.442-.55.885-.734 1.032v.148h0",
  opacity: "undefined",
  stroke: "#000",
  fill: "none"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.675 20.112v-1.278-1.279-.983-.59c0-.098.015-.296 0-.393-.05-.307-.197-.393-.197-.492 0-.196-.068-.313-.197-.491-.081-.113-.143-.167-.196-.295-.038-.091 0-.099 0-.099h-.099v1.475c0 .197-.146.382-.196.689-.016.097-.099.295-.197.491-.098.197-.098.393-.098.492 0 .098-.03.127-.099.196-.07.07.03.215-.098.394-.081.113-.098.098-.098.098 0-.098-.048-.376-.099-.59-.045-.191-.047-.376-.098-.59-.068-.287-.048-.474-.098-.688-.023-.096 0-.393 0-.59v-.492-.393s.022.003 0 .098c-.05.214-.023.31-.099.492a1.813 1.813 0 00-.098.492v.295c0 .098.029.127.098.196.07.07.099.197.197.295h.492c.098 0 .159-.007.196-.098.054-.129.099-.098.099-.197v-.393-.295c0-.098.07-.324 0-.393-.07-.07-.03-.128-.099-.197l-.098-.098V16.572c0 .099.045.167.098.295.038.091 0 .098 0 .197 0 .098.099.098.099.196v.197c0 .098.098.098.098.197 0 0 0 0 0 0v.196s0 0 0 0v-.098h0",
  opacity: "undefined",
  strokeDasharray: "null",
  strokeWidth: "null",
  stroke: "#fff",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: "undefined",
  strokeOpacity: "null",
  strokeDasharray: "null",
  strokeWidth: "null",
  stroke: "#fff",
  fill: "none",
  d: "M4.838 15.294h1.868v3.54H4.838zM.905 15.294h1.868v3.54H.905z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.903 19.719v-.197-.787-.59c0-.295-.034-.577-.197-1.081-.125-.386-.343-.671-.393-.885-.045-.191-.144-.265-.197-.393-.038-.091-.098-.099-.098-.099s-.099.197-.099.394c0 .295 0 .59-.098.983s-.197.786-.197 1.081v.689c0 .098-.098.295-.098.491v-.196-.885-1.672-1.671-.59h0M1.888 8.51h-3.835 0M7.886 8.51H5.723h-.394 0-.098",
  opacity: "undefined",
  strokeOpacity: "null",
  strokeDasharray: "null",
  strokeWidth: "null",
  stroke: "#fff",
  fill: "none"
});

function SvgAlphabetI(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default SvgAlphabetI;